export const HEADER = {
  TITLE: 'Coaches for Good',
  SUBTITLE: 'What is ICF Coaches for Good?',
};
